<template>
  <Modal
    idModal="approved-comment"
    titleModal="Comentário"
    @close="openModalRecuserComment"
    @submit="approveComment"
    closeButtonName="Recusar"
    submitButtonName="Aprovar"
    :disableButtons="progressSave || comment.status !== 'ABERTO'"
  >
    <b-row>
      <b-col cols="4" lg="2" md="3" sm="3">
        <b-form-group
          id="input-group-1"
          label="ID do artigo:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="comment.idArticle"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col cols="8" lg="10" md="9" sm="9">
        <b-form-group
          id="input-group-2"
          label="Título do artigo:"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="comment.titleArticle"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="6" md="6" sm="6">
        <b-form-group id="input-group-3" label="Nome:" label-for="input-3">
          <b-form-input
            id="input-3"
            v-model="comment.name"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col lg="6" md="6" sm="6">
        <b-form-group id="input-group-4" label="E-mail:" label-for="input-4">
          <b-form-input
            id="input-4"
            v-model="comment.email"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="6" md="6" sm="6">
        <b-form-group
          id="input-group-5"
          label="Data cadastro:"
          label-for="input-5"
        >
          <b-form-input
            id="input-5"
            v-model="dateCommentFormatted"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col lg="6" md="6" sm="6">
        <b-form-group id="input-group-5" label="Status:" label-for="input-5">
          <b-form-input
            id="input-5"
            v-model="comment.status"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group id="input-group-6" label="Descrição:" label-for="input-7">
          <b-form-textarea
            id="input-7"
            v-model="comment.description"
            rows="4"
            disabled
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="comment.status !== 'ABERTO'">
      <b-col lg="6" md="6" sm="6">
        <b-form-group
          id="input-group-8"
          label="Data atualização:"
          label-for="input-8"
        >
          <b-form-input
            id="input-8"
            v-model="dateUpdateFormatted"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col lg="6" md="6" sm="6">
        <b-form-group
          id="input-group-9"
          label="Atualizado por:"
          label-for="input-9"
        >
          <b-form-input
            id="input-9"
            v-model="comment.user"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="comment.status === 'RECUSADO'">
      <b-col>
        <b-form-group id="input-group-10" label="Motivo:" label-for="input-10">
          <b-form-input
            id="input-10"
            v-model="comment.reason"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <Modal
      idModal="recuse-comment"
      titleModal="Recusar comentário"
      @close="closeModal"
      @submit="recuseComment"
      closeButtonName="Fechar"
      submitButtonName="Recusar"
      :disableButtons="progressSave || comment.status !== 'ABERTO'"
      ok-only
      sizeModal="md"
    >
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-11"
            label="Motivo:"
            label-for="input-11"
          >
            <b-form-input
              id="input-11"
              v-model="reason"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </Modal>
  </Modal>
</template>


<script>
import Modal from "../Modal.vue";
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import { formatDateTime } from "@/config/util";

export default {
  components: { Modal },
  props: ["comment"],
  data: function () {
    return {
      progressSave: false,
      reason: "",
      closeModalApproved: () => {},
    };
  },
  computed: {
    dateCommentFormatted() {
      return formatDateTime(this.comment.dateRegister);
    },
    dateUpdateFormatted() {
      return formatDateTime(this.comment.dateUpdate);
    },
  },
  methods: {
    openModalRecuserComment(eventHideModal) {
      this.closeModalApproved = eventHideModal;
      this.$bvModal.show("recuse-comment");
    },
    recuseComment(eventHideModal) {
      if (this.reason === "") {
        showError("Escreva o motivo");
        return;
      }
      const data = {
        reason: this.reason,
      };

      this.progressSave = true;
      axios
        .put(
          `${baseApiUrl}/api/artigos/${this.comment.idArticle}/comentarios/${this.comment.id}/reprovacao`,
          data
        )
        .then((res) => {
          if (res !== undefined) {
            this.progressSave = false;
            this.$toasted.global.defaultSuccess();
            eventHideModal();
            this.closeModalApproved();
            this.$emit("updateComment", res.data);
          }
        })
        .catch((res) => {
          showError(res);
          this.progressSave = false;
        });
    },
    approveComment(eventHideModal) {
      this.progressSave = true;
      axios
        .put(
          `${baseApiUrl}/api/artigos/${this.comment.idArticle}/comentarios/${this.comment.id}/aprovacao`
        )
        .then((res) => {
          if (res !== undefined) {
            this.progressSave = false;
            this.$toasted.global.defaultSuccess();
            eventHideModal();
            this.$emit("updateComment", res.data);
          }
        })
        .catch((res) => {
          showError(res);
          this.progressSave = false;
        });
    },
    closeModal(eventHideModal) {
      this.reason = "";
      eventHideModal();
    },
  },
};
</script>